import { useIntl } from 'react-intl';
import { ActionIcon, Checkbox, Group, Stack, Text } from '@mantine/core';
import { CustomInput } from '../../CustomInput';
import { IconTrash } from '@tabler/icons-react';
import { PhotoFetchModal } from './PhotoFetchModal';
import { ImageFile } from '../fields/types';

interface ImagePickerConfigProps {
  maxSelection: number;
  availableImages: ImageFile[];
  imagesAutoImport?: boolean;
  onMaxSelectionChange: (value: number) => void;
  onPhotosAdded: (images: ImageFile[], folderPath: string) => void;
  onRemoveImage: (index: number) => void;
  onImagesAutoImportChange?: (value: boolean) => void;
}

export const ImagePickerConfig = ({
  maxSelection,
  availableImages,
  imagesAutoImport,
  onMaxSelectionChange,
  onPhotosAdded,
  onRemoveImage,
  onImagesAutoImportChange,
}: ImagePickerConfigProps) => {
  const intl = useIntl();

  return (
    <Stack gap="md">
      <CustomInput
        type="number"
        value={String(maxSelection || 1)}
        name="maxSelection"
        label={intl.formatMessage({ id: 'maxSelection' })}
        onChange={(value) => onMaxSelectionChange(Number(value) || 1)}
      />

      {onImagesAutoImportChange && (
        <Checkbox
          label={intl.formatMessage({ id: 'imagesAutoImport' })}
          checked={imagesAutoImport !== undefined ? imagesAutoImport : true}
          onChange={(event) =>
            onImagesAutoImportChange(event.currentTarget.checked)
          }
        />
      )}

      <PhotoFetchModal onPhotosAdded={onPhotosAdded} />

      {availableImages.length > 0 && (
        <Group align="center" justify="end">
          <Text size="sm" c="dimmed">
            {intl.formatMessage(
              { id: 'totalImagesImported' },
              { count: availableImages.length }
            )}
          </Text>
          <ActionIcon
            variant="default"
            onClick={() => {
              // Remove all images (remove from end to beginning to avoid index shifting)
              for (let i = availableImages.length - 1; i >= 0; i--) {
                onRemoveImage(i);
              }
            }}
            title={intl.formatMessage({ id: 'clearAll' })}
          >
            <IconTrash size={16} />
          </ActionIcon>
        </Group>
      )}
    </Stack>
  );
};
